import React from 'react';
import Home from './Home';
import Layout from '../../components/Layout';

async function action({ client, store }) {
  const title = store.getState().siteSettings.data.siteTitle
  const description = store.getState().siteSettings.data.metaDescription;
  let homeHeader = 'homeHeader';
  
  return {
    title,
    description,
    component: (
      <Layout homeHeader={homeHeader}>
        <Home />
      </Layout>
    ),
  };
}

export default action;